<template>
	<div class="home">
		<el-carousel :interval="5000" class="h530">
			<el-carousel-item class="h530">
				<div class="mybox" :style="{backgroundImage: 'url('+require('../../assets/home/swiper-1.png')+')'}">
					<h2 class="myTit">定制加工，专业配送，重构钢材新零售模式</h2>
				</div>
			</el-carousel-item>
			<el-carousel-item class="h530">
				<div class="mybox" :style="{backgroundImage: 'url('+require('../../assets/home/swiper-2.png')+')'}">
					<h2 class="myTit">创建低碳经济,突破传统钢材销售的桎梏</h2>
				</div>
			</el-carousel-item>
			<el-carousel-item class="h530">
				<div class="mybox" :style="{backgroundImage: 'url('+require('../../assets/home/swiper-3.png')+')'}">
					<h2 class="myTit">为钢铁供应链提供更完善的服务</h2>
				</div>
			</el-carousel-item>
			<el-carousel-item class="h530">
				<div class="mybox" :style="{backgroundImage: 'url('+require('../../assets/home/swiper-4.png')+')'}">
					<h2 class="myTit">钢铁意志，砥砺前行</h2>
				</div>
			</el-carousel-item>
			<el-carousel-item class="h530">
				<div class="mybox" :style="{backgroundImage: 'url('+require('../../assets/home/swiper-5.png')+')'}">
					<h2 class="myTit">我们一起，共铸钢铁般的盛世</h2>
				</div>
			</el-carousel-item>
		</el-carousel>
		<div style="width:1303px;margin:auto;">
			<!-- 定制加工 -->
			<div style="width:100%;margin-top: 10px;">
				<div class="mytitle">定制加工</div>
				<div class="mytitle1">Customized processing</div>
				<img src="../../assets/home/Customized-1303_443.png" />
			</div>
			<!-- 产品类型 -->
			<div class="main-protype" style="width:100%;margin-top: 4px;">
				<div class="mytitle">产品类型</div>
				<div class="mytitle1">Product category</div>
				<div class="main-protype-imgbox">
					<div id="proL" class="mr50">
						<div class="box">
							<img src="../../assets/home/lz-3X-406_286.jpg">
							<div class="box-content">
								<h3 class="title">冷轧</h3>
								<span class="post">Cold Rolling</span>
							</div>
						</div>
					</div>
					<div id="proL" class="mr50">
						<div class="box">
							<img src="../../assets/home/sx-3X-406_286.jpg">
							<div class="box-content">
								<h3 class="title">酸洗</h3>
								<span class="post">Acid Picklin</span>
							</div>
						</div>
					</div>
					<div id="proL" class="mr50">
						<div class="box">
							<img src="../../assets/home/td-3X.jpg">
							<div class="box-content">
								<h3 class="title">涂镀</h3>
								<span class="post">Coating</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 汽车用高强度冷连轧钢板及钢带 -->
			<div style="width:100%;margin-top: 4px;">
				<div style="width:100%;height: 40px;line-height: 40px;font-size: 24px; text-align: left;">汽车用高强度冷连轧钢板及钢带
				</div>
				<div
					style="width:100%;height: 30px;line-height: 30px; font-size: 12px;text-align: left;color:cornflowerblue">
					Continuously cold rolled high strength steel sheet and strip for automobile</div>
				<div style="width:100%;height: 30px;line-height: 30px; font-size: 12px;text-align: left;">
					现代汽车工业的发展趋势是在保证安全性能不变的前提下尽可能轻量化以降低油耗和排放，汽车轻量化的首选材料就是高强度钢。</div>
				<div>
					<div class="swiper-card">
						<div class="swiper-slide">
							<!-- 第1个卡片 -->
							<div class="card">
								<div class="content">
									<h2>01</h2>
									<h3>烘烤硬化钢</h3>
									<h4>Bake hardening steel</h4>
									<p>即BH钢，其所含的Nb和Ti没有IF钢种中的含量高，使得BH钢中含有一定数量的间隙原子，但这些间隙原子并没有影响其冲压性能，或者影响不大。适用于制造汽车外板、内板和部分结构件。
									</p>
									<a class="content_but" href="BH_Steel.html">了解更多...</a>

								</div>
							</div>
							<!-- 第2个卡片 -->
							<div class="card">
								<div class="content">
									<h2>02</h2>
									<h3>双相钢</h3>
									<h4>Dual phase steel</h4>
									<p>DP钢的显微组织主要为铁素体和马氏体，也可有少部分贝氏体组织。具有较高的抗拉强度水平，且具有较低的屈强比和较高的加工硬化率。适用于制造汽车结构件、加强件以及部分内外板。
									</p>
									<a class="content_but" href="DP_Steel.html">了解更多...</a>
								</div>
							</div>
							<!-- 第3个卡片 -->
							<div class="card">
								<div class="content">
									<h2>03</h2>
									<h3>高强度无间隙原子钢</h3>
									<h4>High strength interstitial free steel</h4>
									<p>在无间隙原子钢中添加一定量的磷、锰、硅等强化元素，使钢在具有较高强度的同时又保持良好的成形性能。适用于制造汽车外板、内板和部分结构件。</p>
									<a class="content_but" href="IF_Seetl.html">了解更多...</a>
								</div>
							</div>
							<!-- 第4个卡片 -->
							<div class="card">
								<div class="content">
									<h2>04</h2>
									<h3>低合金高强度钢</h3>
									<h4>High strength low alloy steel</h4>
									<p>在低碳钢中，通过单一或复合添加铌、钛、钒等微合金元素，形成碳氮化合物粒子析出进行强化，同时通过微合金元素的细花晶粒作用，以获得较高的强度。主要用于制作汽车结构件和加强件。
									</p>
									<a class="content_but" href="LA_Steel.html">了解更多...</a>
								</div>
							</div>
						</div>
					</div>
					<div class="swiper-card">
						<div class="swiper-slide">
							<!-- 第5个卡片 -->
							<div class="card">
								<div class="content">
									<h2>05</h2>
									<h3>各向同性钢</h3>
									<h4>Isotopic steel</h4>
									<p>各向同性高强钢是对塑性应变比(r值)进行限定的钢。由于这种钢的各向同性性能，因此具有良好的拉伸成形性能，适合于汽车外覆盖件的制作。</p>
									<a class="content_but" href="IS_Steel.html">了解更多...</a>
								</div>
							</div>
							<!-- 第6个卡片 -->
							<div class="card">
								<div class="content">
									<h2>06</h2>
									<h3>相变诱导塑性钢</h3>
									<h4>Transformation induced plasticity steel</h4>
									<p>由钢组织中逐步进行的马氏体相变过程导致的塑性升高的超高强度钢，简称TRIP钢。主要用于制作汽车的结构件和加强件。</p>
									<a class="content_but" href="TRIP_Steel.html">了解更多...</a>
								</div>
							</div>
							<!-- 第7个卡片 -->
							<div class="card">
								<div class="content">
									<h2>07</h2>
									<h3>马氏体钢</h3>
									<h4>Martensitic steels</h4>
									<p>马氏体钢的显微组织几乎全部为马氏体组织，马氏体钢具有较高的抗拉强度和一定的成形性能。主要用于成形要求不高的车门防撞杆等零件以代替管状零件，降低制造成本。</p>
									<a class="content_but" href="MS_Steel.html">了解更多...</a>
								</div>
							</div>
							<!-- 第8个卡片 -->
							<div class="card">
								<div class="content">
									<h2>08</h2>
									<h3>复相钢</h3>
									<h4>Complex phase steel</h4>
									<p>CP钢的显微组织是铁素体或贝氏基体上分布少量马氏体、残余奥氏体或珠光体。通过微合金元素细晶强化或析出强化。与同等抗拉强度低双相钢比，具有较高的屈服强度和良好的弯曲性能。主要用于制造汽车结构件、加强件及部分内外板。
									</p>
									<a class="content_but" href="#">了解更多...</a>
								</div>
							</div>
						</div>
					</div>
					<div class="swiper-card">
						<div class="swiper-slide">
							<!-- 第9个卡片 -->
							<div class="card">
								<div class="content">
									<h2>09</h2>
									<h3>淬火配分钢</h3>
									<h4>Quenching and partitioning steel</h4>
									<p>QP钢是通过碳配分过程使组织获得更多残余奥氏体的马氏体钢。它属于第三代汽车用钢，具有高强度的同时也具有很高的塑韧性。主要用于制造汽车结构件和加强件。</p>
									<a class="content_but" href="QP_Steel.html">了解更多...</a>
								</div>
							</div>
							<!-- 第10个卡片 -->
							<div class="card">
								<div class="content">
									<h2>10</h2>
									<h3>孪晶诱导塑性钢</h3>
									<h4>Twinning induced plasticity steel</h4>
									<p>更加深人的成分优化，以探求更高强塑积或性能稳定性，TWIP钢不仅强度高，而且成形性好，是先进高强度钢的研究热点。用于制造成形复杂的结构件或加强件。</p>
									<a class="content_but" href="TWIP_Steel.html">了解更多...</a>
								</div>
							</div>
							<!-- 第11个卡片 -->
							<div class="card">
								<div class="content">
									<h2>11</h2>
									<h3>碳锰钢</h3>
									<h4>Carbon manganese steel</h4>
									<p>碳锰钢，是指一组中、高强度钢，通过正确选择化学成分和热轧轧制工艺生产的产品，具有改善的成形性和韧性。这些钢中，通过提高锰含量来增加淬硬深度，改善强度和韧性。主要用于制造汽车结构件。
									</p>
									<a class="content_but" href="CM_Steel.html">了解更多...</a>
								</div>
							</div>
							<!-- 第12个卡片 -->
							<div class="card">
								<div class="content">
									<h2>12</h2>
									<h3>增强成形性双相钢</h3>
									<h4>Dual phase steel with high formability</h4>
									<p>增强成形性双相钢在保证原有双相钢强度的同时，提升了材料的延伸率，适合于制造成形复杂汽车结构件、加强件。</p>
									<a class="content_but" href="DPH_Steel.html">了解更多...</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 行业应用 -->
			<div style="width:100%;margin-top: 4px;">
				<div class="mytitle">行业应用</div>
				<div class="mytitle1">Industry application</div>
				<div class="main-application">
					<div class="imgbox">
						<div class="imgitem frsb">
							<div class=" box1">
								<img class="bigimg" src="../../assets/home/汽车行业-3X-794_386.jpg">
							</div>
							<div class=" box2">
								<img class="smallimg" src="../../assets/home/电脑行业-3X-382_386.jpg">

							</div>
						</div>
						<div class="imgitem frsb">
							<div class=" box2">
								<img class="smallimg" src="../../assets/home/建筑-3X-382_386.jpg">
							</div>
							<div class=" box1">
								<img class="bigimg" src="../../assets/home/家电-3X-794_386.jpg">
							</div>
						</div>
						<div class="imgitem frsb">
							<div class="inbox1">
								<img class="inimg" src="../../assets/home/公交站-3X-382_269.jpg">
							</div>
							<div class="inbox1">
								<img class="inimg" src="../../assets/home/地铁-3X-382_269.jpg">
							</div>
							<div class="inbox1">
								<img class="inimg" src="../../assets/home/门锁-3X-382_269.jpg">
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
		<div
			style="width:100%;background-color: #efefef;text-align: center; height: 50px;line-height: 50px;border-top: 1px solid #ccc; margin-bottom: 2px;">
			2022 重庆市离离科技有限公司 备案 渝ICP备2020011628号-1
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return{
				
			}
		}
	}
</script>

<style scoped lang="less">
	.mytitle {
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 24px;
	}

	.mytitle1 {
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 18px;
	}

	.h530 {
		margin: 6px;
		height: 530px;
	}

	.mr50 {
		margin-right: 50px;
	}

	.main-protype {
		margin-top: 40px;

		.main-protype-imgbox {
			display: flex;
			justify-content: space-between;
			margin-bottom: 40px;
			position: relative;

			div {
				width: 32%;
				height: 260px;
				position: relative;
				overflow: hidden;
				cursor: pointer;
				margin: auto;

				.box {
					font-family: 'Ubuntu', sans-serif;
					overflow: hidden;
					position: relative;
					transition: all 0.3s;
					width: 100%;
				}

				.box:hover {
					box-shadow: 0 0 15px -5px #000;
				}

				.box:before {
					content: '';
					background-color: transparent;
					background-image: radial-gradient(circle at 20% 80%, transparent 29%, rgba(255, 255, 255, 0.4) 30%, rgba(255, 255, 255, 0.4) 33%, transparent 34%), radial-gradient(circle at 80% 20%, transparent 29%, rgba(255, 255, 255, 0.4) 30%, rgba(255, 255, 255, 0.4) 33%, transparent 34%);
					background-size: 30px 30px;
					height: 100%;
					width: 100%;
					opacity: 0;
					position: absolute;
					left: 0;
					top: 0;
					z-index: 1;
					transition: all 0.3s ease 0.2s;
				}

				.box:hover:before {
					opacity: 1;
				}

				.box img {
					width: 100%;
					height: auto;
					transition: all 0.3s ease 0s;
				}

				.box:hover img {
					filter: blur(2px);
				}

				.box .box-content {
					color: #fff;
					background-color: rgba(0, 0, 0, 0.6);
					text-align: center;
					width: 100%;
					height: 30%;
					padding: 18% 0 0 0;
					position: absolute;
					left: 0;
					top: -100%;
					z-index: 2;
					transition: all 0.3s ease 0s;
				}

				.box:hover .box-content {
					top: 0;
				}

				.box .title {
					color: #fff;
					font-size: 23px;
					font-weight: 600;
					letter-spacing: 1px;
					text-transform: uppercase;
					margin: 0;
				}

				.box .post {
					color: #32c287;
					font-size: 14px;
					font-style: italic;
					text-transform: capitalize;
					letter-spacing: 2px;
				}

				@media only screen and (max-width:990px) {
					.box {
						margin-bottom: 30px;
					}
				}

				@media only screen and (max-width:479px) {
					.box .title {
						font-size: 20px;
					}
				}
			}
		}





		h4 {
			font-size: 36px;
			color: #002664;
			font-weight: 500;
			margin-bottom: 10px;
		}

		.main-protype-enintur {
			color: #002664;
			margin-bottom: 15px;
		}

		p {
			color: #7e7e7e;
		}

		.mySwiper {
			margin-top: 40px;

			.swiper-slide {
				display: flex;
				justify-content: space-between;

				.main-protype-swiperitem {
					margin-left: 25px;
					flex: 1;
					width: 22%;
					position: relative;

					img {
						width: 100%;
					}

					.item-bottom {
						cursor: pointer;
						position: absolute;
						bottom: 5%;
						right: 5%;
						width: 100px;
						display: flex;
						justify-content: space-between;
						align-items: center;

						img {
							width: 35px;
							height: 35px;
						}

						p {
							font-size: 0.2rem;
							color: #002664;
						}
					}
				}
			}
		}
	}


	.frsb {
		display: flex;
		justify-content: space-between;
	}

	.main-application {
		width: 100%;
		margin-top: 40px;
		margin-bottom: 80px;

		img {
			transition: all 0.9s;
		}

		.imgitem>div:hover>img {
			transform: scale(1.3);
		}

		.inbox1:hover>img {
			transform: scale(1.3);
		}

		.inbox:hover>img {
			transform: scale(1.3);
		}

		.inbox1 {
			position: relative;
		}

		.inbox {
			position: relative;
		}

		.imgbox {
			width: 100%;

			.imgitem>div {
				position: relative;
			}

			.imgitem {
				display: flex;
				box-sizing: border-box;
				margin-top: 40px;

				.box1 {
					overflow: hidden;
					width: 66%;
					box-sizing: border-box;

					.bigimg {
						width: 100%;
					}
				}

				.box2 {
					overflow: hidden;
					width: 32%;
					box-sizing: border-box;

					.smallimg {
						width: 100%;
					}
				}

				.inbox1 {
					width: 32%;
					overflow: hidden;
				}

				.inbox {
					width: 100%;
					overflow: hidden;
				}

				.inimg {
					width: 100%;
				}
			}
		}
	}

	.swiper-card {
		display: block;
		/* flex容器（flex container） */
		justify-content: center;
		/* 定义项目在主轴上的对齐方式 */
		align-items: center;
		/* 定义项目在竖直方向上对齐方式 */
		height: 400px;
		position: relative;
		background: #161623;
	}

	.swiper-card::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 80%;
		height: 80%;
		background: linear-gradient(#2196f3, #e91e63);
		clip-path: circle(20% at 10% 10%);
		/* circle()可以传人2个可选参数；
		1. 圆的半径，默认元素宽高中短的那个为直径，支持百分比
		2. 圆心位置，默认为元素中心点 */
	}

	.swiper-slide {
		position: relative;
		display: flex;
		/* flex容器（flex container） */
		justify-content: center;
		/* 定义项目在主轴上的对齐方式 */
		align-items: center;
		/* 定义项目在竖直方向上对齐方式 */
		margin: 20px auto;
		padding-top: 10px;
		max-width: 90%;
		flex-wrap: nowrap;
		/* 定义项目是否换行以及如何换行  */
		z-index: 1;
	}

	.swiper-slide .card {
		position: relative;
		width: 24%;
		height: 360px;
		margin: 10px;
		/* 设置阴影 */
		box-shadow: 20px 20px 50px rgba(0, 0, 0, 0.5);
		border-radius: 15px;
		/* 设置card的背景色 */
		background: rgba(255, 255, 255, 0.1);
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
		border-top: 1px solid rgba(255, 255, 255, 0.5);
		border-left: 1px solid rgba(255, 255, 255, 0.5);
		backdrop-filter: blur(5px);

	}

	.swiper-slide .card .content {
		padding: 20px;
		text-align: center;
		/* transform: translateY(100px); */
		/* opacity: 0; */
		/* transition: 0.5s; */
	}

	/*  .swiper-slide .card:hover .content{
    transform: translateY(0px);
    opacity: 1;
} */
	.swiper-slide .card .content h2 {
		position: absolute;
		top: -60px;
		right: 1px;
		font-size: 10em;
		color: rgba(255, 255, 255, 0.05);
		pointer-events: none;


	}

	.swiper-slide .card .content h3 {
		font-size: 1.6em;
		color: #fff;
		z-index: 1;
	}

	.swiper-slide .card .content h4 {
		font-size: 1.0em;
		color: #fff;
		z-index: 2;

	}

	.swiper-slide .card .content p {
		font-size: 1em;
		color: #fff;
		font-weight: 300;
		text-align: justify;

	}


	.swiper-slide .card .content .content_but {
		width: 80px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		color: #fff;
		font-size: 12px;
		border: 0;
		border-radius: 25px;
		cursor: pointer;
		-webkit-transition: all .3s;
		transition: all .3s;
		background-color: #ca3535;
		border-color: #c43c35;
		position: relative;
		display: inline-block;
		text-decoration: none;
		font-weight: 500;
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
	}

	.swiper-slide .card .content .content_but:hover {
		background-color: #ee5f5b;
		;
		box-shadow: 0px 0px 20px #195ad1;
		-webkit-transition: all .3s;
		transition: all .3s;
	}

	.swiper-slide .card .content .content_but:active {
		background: #c43c35;
	}

	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 150px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}

	.mybox {
		width: 100%;
		height: 530px;
		padding-top: 80px;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.myTit {
		letter-spacing: 6px;
		color: darkorange
	}
</style>
